import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNewestComments } from '../../../actions';
import { Grid } from 'semantic-ui-react';
import { Avatar } from '@plone/volto/components';
import { flattenToAppURL, getColor } from '@plone/volto/helpers';

const defaultComments = [];

const DashboardComments = () => {
  const dispatch = useDispatch();
  const comments =
    useSelector((state) => state?.newestcomments?.result) || defaultComments;

  React.useEffect(() => {
    dispatch(getNewestComments());
  }, [dispatch]);

  return (
    <>
      <div className={'dashboard-comments'}>
        <Grid padded textAlign="center" verticalAlign="middle">
          <Grid.Row className={'comment comment-header'} as={'div'} key={99999}>
            <Grid.Column
              computer={1}
              tablet={1}
              mobile={2}
              className={'avatar'}
            ></Grid.Column>
            <Grid.Column
              computer={9}
              tablet={9}
              mobile={7}
              className={'content'}
            ></Grid.Column>
            <Grid.Column computer={2} tablet={2} mobile={3} className={'date'}>
              Erstellung
            </Grid.Column>
          </Grid.Row>
          {comments.length > 0 &&
            comments.map(function (comment, i) {
              return (
                <Grid.Row
                  className={'comment'}
                  as={'a'}
                  href={comment.url}
                  key={i}
                >
                  <Grid.Column
                    computer={1}
                    tablet={1}
                    mobile={2}
                    className={'avatar'}
                  >
                    <Avatar
                      src={flattenToAppURL('/@portrait/' + comment.creator)}
                      title={comment.creator}
                      color={getColor(comment.creator)}
                      userId={comment.creator}
                      preventDefault
                    />
                  </Grid.Column>
                  <Grid.Column
                    computer={9}
                    tablet={9}
                    mobile={7}
                    className={'content'}
                  >
                    <div className={'title'}>{comment.title}</div>
                    <div className={'text'}>{comment.text}</div>
                  </Grid.Column>
                  <Grid.Column
                    computer={2}
                    tablet={2}
                    mobile={3}
                    className={'date'}
                  >
                    {comment.date}
                  </Grid.Column>
                </Grid.Row>
              );
            })}
        </Grid>
      </div>
    </>
  );
};

export default DashboardComments;
